module.exports = __webpack_public_path__ + "static/media/5.b72ce5d5.png";